import React from "react";
import style from "../styles/about.module.scss";
import { Card } from "../components/ui/Card";
import cardImg from "../assets/images/cardImage.png";

const AboutUs = () => {
  return (
    <div className={style.wrapper}>
      <div className={style.about}>
        <section>
          <h2 className={style.header}>About Hopa</h2>
          <p className={style.description}>
            At Hopa UK, we are redefining wellness with our premium range of
            vitamins, designed to support your health and vitality at every
            stage of life. Based in the United Kingdom, we are committed to
            delivering exceptional quality, innovation, and trust in every
            product we create. Our mission is simple yet profound: to empower
            individuals to take charge of their health with confidence, backed
            by the science of superior nutrition.
          </p>
        </section>

        <section>
          <h2 className={style.header}>Our Philosophy</h2>
          <p>
            We believe that true well-being begins with the right nutrition.
            That’s why we meticulously formulate each product using only the
            highest-quality ingredients, carefully selected to support a wide
            range of health needs and lifestyles. Our approach is rooted in
            scientific research, ensuring that every supplement is crafted to
            deliver real, measurable benefits.
          </p>
          <p>
            We recognize that no two individuals are the same, which is why we
            offer tailored solutions to help you achieve your personal health
            goals—whether it’s boosting immunity, enhancing energy levels,
            supporting cognitive function, or promoting overall wellness.
          </p>
          <div className={style.cardsContainer}>
            <Card
              img={cardImg}
              header={"Uncompromising Quality"}
              desc={
                "Each vitamin is crafted to perfection, ensuring optimal potency and purity."
              }
              key={1}
            />
            <Card
              img={cardImg}
              header={"Premium Ingredients"}
              desc={
                "We source only the finest ingredients from trusted suppliers around the world."
              }
              key={2}
            />
            <Card
              img={cardImg}
              header={"Innovation in Wellness"}
              desc={
                "Our advanced formulations are designed to deliver noticeable results and elevate your overall well-being."
              }
              key={3}
            />
          </div>
        </section>

        <section>
          <h2 className={style.header}>Our Commitment</h2>
          <p>
            Your health is our priority, and we are dedicated to supporting you
            on your wellness journey. Whether you’re looking to enhance your
            daily nutrition or address specific health concerns, Hopa UK
            provides premium supplements you can trust.
          </p>

          <p>
            From stringent quality testing to customer-centric service, we go
            the extra mile to ensure that every product meets the highest
            standards of excellence. We believe that good health is the
            foundation of a fulfilling life, and we’re here to help you achieve
            it—one supplement at a time.
          </p>

          <p>
            Join the Hopa UK Wellness RevolutionWellness is more than just a
            product—it’s a lifestyle. Join us on the path to better health and
            discover how our expertly crafted vitamins can transform your daily
            routine. At Hopa UK, we don’t just support well-being; we inspire
            it. Experience the difference with Hopa UK—where science meets
            nature, and quality meets trust.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
